import { } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import { Form } from '@ant-design/compatible';

// import '@ant-design/compatible/assets/index.css';


import EditableContext from './EditableContext';

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
    <tr {...props} />
  </EditableContext.Provider>
);

EditableRow.propTypes = {
  form: PropTypes.object,
  index: PropTypes.object,
};

const EditableFormRow = Form.create()(EditableRow);

export default EditableFormRow;
